<app-nav [navItems]="navItems" />
<div class="static">
  <h1>FAQ</h1>
  <p>
    Welcome to the ImageBase.pro FAQ section! Here you’ll find answers to the
    most common questions about our platform, services, and policies. If you
    don’t find what you’re looking for, feel free to reach out to our support
    team.
  </p>
  <div class="faq">
    <h2>General Questions</h2>
    <div class="faq__item">
      <div class="faq__question">1. What is ImageBase.pro?</div>
      <div class="faq__answer">
        ImageBase.pro is a professional photostock created by
        <strong>DIGITAL DP LTD</strong>. We offer a collection of high-quality
        paid and free images across a wide range of themes. All our content is
        either produced by our in-house team or commissioned from professional
        photographers to ensure top-notch quality.
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">
        2. How is ImageBase.pro different from other stock photo platforms?
      </div>
      <div class="faq__answer">
        Unlike most platforms that act as intermediaries for user-generated
        content, we focus on curating and creating original, high-quality photos
        ourselves. This guarantees consistent quality and unique visuals for
        your projects.
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">3. Who can use ImageBase.pro?</div>
      <div class="faq__answer">
        Our platform is designed for everyone—creatives, designers,
        photographers, marketers, and businesses. Whether you’re a beginner or a
        seasoned professional, our collection is tailored to meet your needs.
      </div>
    </div>
    <h2>Content and File Formats</h2>
    <div class="faq__item">
      <div class="faq__question">4. Can I download RAW files?</div>
      <div class="faq__answer">
        Yes, we offer access to RAW files for most of our premium images, giving
        you the flexibility to fine-tune and edit them according to your
        requirements.
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">5. Are there any free photos available?</div>
      <div class="faq__answer">
        Absolutely! We offer a curated selection of high-quality free images for
        you to download and use without any cost.
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">6. What types of content are available?</div>
      <div class="faq__answer">
        Our library includes photographs across various categories, such as
        nature, business, lifestyle, technology, travel, and more.
      </div>
    </div>
    <h2>Licensing and Usage</h2>
    <div class="faq__item">
      <div class="faq__question">
        7. What are the licensing terms for your photos?
      </div>
      <div class="faq__answer">
        Our images are provided under flexible licenses, making them suitable
        for personal, commercial, and professional use. For detailed licensing
        terms, please refer to our
        <a class="faq__link" routerLink="/licensing-policy">Licensing Policy</a
        >.
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">
        8. Can I use your photos for commercial projects?
      </div>
      <div class="faq__answer">
        Yes, our premium photos come with commercial usage rights. Free photos
        may have specific usage restrictions, so please check the license
        details for each image.
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">
        9. Are there any restrictions on how I can use the photos?
      </div>
      <div class="faq__answer">
        While our licenses are flexible, there are certain restrictions, such as
        resale or redistribution of the files in their original form. For full
        details, please read our
        <a class="faq__link" routerLink="/terms-of-use">Terms of Use</a>.
      </div>
    </div>
    @if (false) {
      <h2>Payments and Subscriptions</h2>
    } @else {
      <h2>Payments</h2>
    }
    <div class="faq__item">
      <div class="faq__question">10. How do I purchase images?</div>
      @if (false) {
        <div class="faq__answer">
          You can purchase images individually or opt for one of our
          subscription plans for bulk downloads at a discounted rate. Simply add
          your desired images to the cart and proceed to checkout.
        </div>
      } @else {
        <div class="faq__answer">
          You can purchase images. Simply add your desired images to the cart
          and proceed to checkout.
        </div>
      }
    </div>
    <div class="faq__item">
      <div class="faq__question">11. What payment methods do you accept?</div>
      <div class="faq__answer">
        We accept major credit cards, PayPal, and other popular payment methods.
      </div>
    </div>
    @if (false) {
      <div class="faq__item">
        <div class="faq__question">
          12. Are there subscription plans available?
        </div>
        <div class="faq__answer">
          Yes, we offer a variety of subscription plans tailored to your needs.
          Visit our
          <a class="faq__link" routerLink="/plans">Pricing Page</a> for more
          information.
        </div>
      </div>
    }
    <h2>Support and Technical Issues</h2>
    <div class="faq__item">
      @if (false) {
        <div class="faq__question">
          13. What should I do if I encounter issues downloading files?
        </div>
      } @else {
        <div class="faq__question">
          12. What should I do if I encounter issues downloading files?
        </div>
      }
      <div class="faq__answer">
        If you face any technical difficulties, please contact our support team
        through the Contact Us page, and we’ll assist you promptly.
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">14. How can I reach your support team?</div>
      <div class="faq__answer">
        You can contact our support team via email or the live chat feature on
        our website. We’re here to help!
      </div>
    </div>
    <div class="faq__item">
      <div class="faq__question">15. Do you offer refunds?</div>
      <div class="faq__answer">
        Refunds are available in specific cases, such as technical issues or
        incorrect billing. Please review our
        <a class="faq__link" routerLink="/refund-policy">Refund Policy</a> for
        more details.
      </div>
    </div>
  </div>

  <p>
    We hope this FAQ has been helpful! If you have additional questions, don’t
    hesitate to reach out. Thank you for choosing ImageBase.pro!
  </p>
</div>
